import type { DocumentCopyTypeOptionModel } from '../models/dto/document-copy-config.dto';
import { CopyDocumentType } from '../models/entity';

/**
 * PD-15003 — the customer-facing documents that can carry configured copies,
 * in the order the settings screen shows them.
 *
 * Deliberately a short explicit list rather than every value of
 * CopyDocumentType: each entry needs wording that says what the document IS to
 * a customer, and adding a new document is a code change anyway (a send path
 * has to resolve recipients). Labels are English; wrap with t() in the UI.
 */
export const DOCUMENT_COPY_TYPES: ReadonlyArray<DocumentCopyTypeOptionModel> = [
	{
		value: CopyDocumentType.WEBSITE_ORDER,
		label: 'Website order confirmation',
		description:
			'Sent to the customer when they place an order on your storefront. An order held for approval is confirmed once it is approved.',
		detail:
			'Website orders only. Orders entered in the CRM send their own confirmation, which this list is not added to.',
	},
	{
		value: CopyDocumentType.INVOICE,
		label: 'Invoice',
		description:
			'Sent when someone emails an invoice to a customer from the invoice screen.',
		detail:
			'Anyone typed into the send dialog by hand receives it as well as the people configured here.',
	},
	{
		value: CopyDocumentType.DELIVERY_RECEIPT,
		label: 'Delivery receipt',
		description: 'Sent to the customer automatically when a delivery is completed.',
		detail:
			'It carries the invoice PDF, so anyone configured here has already received that invoice and is not sent it again if it is later emailed by hand.',
	},
	{
		value: CopyDocumentType.CREDIT_MEMO,
		label: 'Credit memo',
		description: 'Sent when someone emails a credit memo to a customer.',
		detail:
			'When nobody is configured here, the Invoice recipients receive it instead, so credits follow invoices unless you route them differently.',
	},
];
